import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import BusinessContextAndRiskLandscape from "../../input-components/qe-strategy/discovery-layer/BusinessContextAndRiskLandscape";
import ApplicationArchitectureAndDataIntegration from "../../input-components/qe-strategy/discovery-layer/ApplicationArchitectureAndDataIntegration";
import DevOpsTestAutoDeveloperExperience from "../../input-components/qe-strategy/discovery-layer/DevOpsTestAutoDeveloperExperience";
import AIMLLLMConsiderations from "../../input-components/qe-strategy/discovery-layer/AIMLLLMConsiderations";
import QualityCultureGovernanceAndTestDebt from "../../input-components/qe-strategy/discovery-layer/QualityCultureGovernanceAndTestDebt";
import ObservabilityForm from "../../input-components/qe-strategy/discovery-layer/ObservabilityResilienceSecurityAndScalability";
import DataCentricAndCapabilityAlignedQA from "../../input-components/qe-strategy/discovery-layer/DataCentricAndCapabilityAlignedQE";
import StepperHeader from "../../custom-components/QMentisStepper";
import { useLocation } from "react-router-dom";

const steps = [
  "Business Context & Risk Landscape",
  "Application Architecture, Data & Integrations",
  "DevOps, Test Automation & Developer Experience",
  "AI/ML/LLM Considerations",
  "Observability, Resilience, Security & Scalability",
  "Quality Culture, Governance & Test Debt",
  "Data-Centric & Capability-Aligned QE",
];

const QEStrategyInputPage = () => {
  const location = useLocation();
  const { outputData } = location.state || {};

  const [currentStep, setCurrentStep] = useState(() => {
    if (outputData) {
      return 0;
    }
    // Load saved step on first render
    const saved = localStorage.getItem("qeStrategyCurrentStep");
    return saved ? Number(saved) : 0;
  });

  useEffect(() => {
    if (!outputData) {
      localStorage.setItem("qeStrategyCurrentStep", currentStep);
    }
  }, [currentStep, outputData]);

  // Save step whenever it changes
  useEffect(() => {
    localStorage.setItem("qeStrategyCurrentStep", currentStep);
  }, [currentStep]);

  //  Next and Back navigation
  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  //  Pass  component for current step
  const renderStepComponent = () => {
    switch (currentStep) {
      case 0:
        return (
          <BusinessContextAndRiskLandscape
            onNext={handleNext}
            onBack={handleBack}
          />
        );

      case 1:
        return (
          <ApplicationArchitectureAndDataIntegration
            onNext={handleNext}
            onBack={handleBack}
          />
        );

      case 2:
        return (
          <DevOpsTestAutoDeveloperExperience
            onNext={handleNext}
            onBack={handleBack}
          />
        );

      case 3:
        return (
          <AIMLLLMConsiderations onNext={handleNext} onBack={handleBack} />
        );

      case 4:
        return <ObservabilityForm onNext={handleNext} onBack={handleBack} />;

      case 5:
        return (
          <QualityCultureGovernanceAndTestDebt
            onNext={handleNext}
            onBack={handleBack}
          />
        );

      case 6:
        return <DataCentricAndCapabilityAlignedQA onBack={handleBack} />;
      default:
        return;
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={3} sx={{ mr: 11 }}>
      <StepperHeader
        steps={steps}
        activeStep={currentStep}
        containerWidth={"1000px"}
      />

      {/*  Step Content */}
      {renderStepComponent()}
    </Box>
  );
};

export default QEStrategyInputPage;
